import React, { useState, useCallback } from "react";
import { Box, Button, Collapse, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

/**
 * Bloco colapsável com curl + resposta (somente quando a API envia `integrationDebug` — tipicamente usuário master).
 * @param {{ integrationDebug?: { curl?: string, response?: { status?: number|null, bodySnippet?: string|null }, provider?: string } } | null | undefined} props
 */
export default function ApiErrorIntegrationDebug({ integrationDebug }) {
  const [open, setOpen] = useState(false);
  const curl = integrationDebug?.curl || "";
  const status = integrationDebug?.response?.status;
  const bodySnippet = integrationDebug?.response?.bodySnippet;
  const provider = integrationDebug?.provider || "";

  const copyText = useCallback(
    (text) => {
      if (!text || typeof navigator === "undefined" || !navigator.clipboard) return;
      navigator.clipboard.writeText(text).catch(() => {});
    },
    []
  );

  if (!integrationDebug || (!curl && status == null && !bodySnippet)) return null;

  return (
    <Box sx={{ mt: 1.5, pt: 1, borderTop: "1px solid", borderColor: "divider" }}>
      <Button
        size="small"
        onClick={() => setOpen((v) => !v)}
        endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        sx={{ textTransform: "none", p: 0, minWidth: 0, fontWeight: 600 }}
      >
        Detalhes para o provedor (master)
        {provider ? ` — ${provider}` : ""}
      </Button>
      <Collapse in={open}>
        <Box sx={{ mt: 1 }}>
          {curl ? (
            <Box sx={{ mb: 1.5 }}>
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                cURL (sanitizado)
              </Typography>
              <Box
                component="pre"
                sx={{
                  p: 1,
                  bgcolor: "action.hover",
                  borderRadius: 1,
                  fontSize: 11,
                  overflow: "auto",
                  maxHeight: 200,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-all",
                }}
              >
                {curl}
              </Box>
              <Button size="small" startIcon={<ContentCopyIcon />} onClick={() => copyText(curl)} sx={{ mt: 0.5 }}>
                Copiar curl
              </Button>
            </Box>
          ) : null}
          {(status != null || bodySnippet) && (
            <Box>
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                Resposta HTTP
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Status: {status != null ? String(status) : "—"}
              </Typography>
              {bodySnippet ? (
                <>
                  <Box
                    component="pre"
                    sx={{
                      p: 1,
                      bgcolor: "action.hover",
                      borderRadius: 1,
                      fontSize: 11,
                      overflow: "auto",
                      maxHeight: 200,
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {bodySnippet}
                  </Box>
                  <Button
                    size="small"
                    startIcon={<ContentCopyIcon />}
                    onClick={() => copyText(`HTTP ${status}\n\n${bodySnippet}`)}
                    sx={{ mt: 0.5 }}
                  >
                    Copiar resposta
                  </Button>
                </>
              ) : null}
            </Box>
          )}
        </Box>
      </Collapse>
    </Box>
  );
}
